let prefix = "ai-5118-messenger";

class Target {
  constructor(target, name) {
    this.target = target;
    this.name = name;
  }

  send(eventName, data) {
    this.target.postMessage({
      eventName: prefix + eventName,
      data
    }, '*');
  };
}

export class Messenger {
  constructor(messengerName, projectName) {
    this.targets = {};
    this.name = messengerName;
    this.listenFunList = [];
    prefix = projectName || prefix;
    this.initListen();
  }

  addTarget(target, name) {
    this.targets[name] = new Target(target, name);
  }

  //初始化监听
  initListen() {
    let generalCallback = (msg) => {
      let data = msg.data || {eventName: "", data: {}};
      // 剥离消息前缀
      try {
        for (let listenFun of this.listenFunList) {
          listenFun && listenFun(data.eventName.slice(prefix.length), data.data || {})
        }
      }
      catch (e) {
      }
    };

    if ('addEventListener' in document) {
      window.addEventListener('message', generalCallback, false);
    } else if ('attachEvent' in document) {
      window.attachEvent('onmessage', generalCallback);
    }
  }

  // 监听消息
  listen(eventName, callback) {
    this.listenFunList.push((name, data) => {
      if (String(name).indexOf(eventName) !== -1) {
        callback && callback(data)
      }
    });
  };

  clear() {
    this.listenFunList = [];
  };

  send(msg) {
    let targets = this.targets;
    for (let target in targets) {
      if (targets.hasOwnProperty(target)) {
        targets[target].send(msg);
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/assets/script/message.js